{
  "confirmationNumber": "确认号 {number}",
  "dateTimeRange": "{date}，{startTime} 至 {endTime}"
}
